import { render } from "./PermissionDenied.vue?vue&type=template&id=3580f02a&scoped=true"
import script from "./PermissionDenied.vue?vue&type=script&lang=js"
export * from "./PermissionDenied.vue?vue&type=script&lang=js"

import "./PermissionDenied.vue?vue&type=style&index=0&id=3580f02a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3580f02a"]])

export default __exports__